/**
 * Description: Review page for the Audit Tool. 
 */
import React from 'react';
import {
  AppLayout
} from 'AWS-UI-Components-React';
import { CustomNavigation } from '../customNavigation.jsx';
import { JSClient } from '../common.jsx';
import { FilterAuditedOutfits } from './filterAuditedOutfitsSection.jsx';
import { BrowseSection } from './browseSection.jsx';

export class Browse extends React.Component {
  constructor(props) {
    super(props);
    this.browseSection = React.createRef();
    this.state = { 
      initialLoadDone: false, 
      user: "", 
      auditBatchResult: [],
      filter_options: {},
      error: ""
    };
    this.clientLoaded = this.clientLoaded.bind(this);
    this.getAuditedOutfitsCallback = this.getAuditedOutfitsCallback.bind(this);
  }

  clientLoaded() {
    this.client.getIdentity(identityResult => {
        this.setState((state, props) => { 
          return ({
            user: identityResult.username,
            initialLoadDone: true 
          });
        });
    });
  }

  componentWillMount() {
    require('../common.jsx');
    this.client = new JSClient({ onReady: 
        this.clientLoaded
    });
    
  }

  getAuditedOutfitsCallback(filter_options) {
    return this.browseSection.current.getNewAuditedOutfits(filter_options);
  }

  render() {
    if (!this.state.initialLoadDone) {
      return (
        <center>
          <h1>Authorizing user please wait...</h1>
        </center>
      );
    }

    const FilterContent = () => (
      <div id="filter">
          <FilterAuditedOutfits getAuditedOutfitsCallback={this.getAuditedOutfitsCallback}/>
      </div>
    );
    
    const BrowseContent = () => (
      <div>
        <div id="reviewSection">
          <BrowseSection 
            user={this.state.user}
            ref={this.browseSection}/>
        </div>
      </div>
    );
    
    return (
      <div className="awsui">
        <AppLayout
          className='awsui-util-no-gutters'
          content={
            <div>
              <FilterContent />
              <BrowseContent />
            </div>
          }
          navigation={<CustomNavigation />}
          toolsHide={true}
          navigationOpen={false}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/browsePage/browsepage.jsx